import gql from 'graphql-tag';
import apollo from '../apollo';

const DELETE_OWN_USER = gql`
  mutation {
    deleteOwnUser
  }
`;

const REMOVE_USER_FROM_ACCOUNT = gql`
  mutation($input: RemoveUserFromAccountInput!) {
    removeUserFromAccount(input: $input)
  }
`;

export const removeUserFromAccount = (input) =>
  apollo
    .mutate({
      mutation: REMOVE_USER_FROM_ACCOUNT,
      variables: {
        input,
      },
    })
    .then((res) => res.data);

export const deleteOwnUser = () => apollo.mutate({ mutation: DELETE_OWN_USER }).then((res) => res.data);

export default {
  removeUserFromAccount,
  deleteOwnUser,
};
